import { render, staticRenderFns } from "./ContextMenuHeader.vue?vue&type=template&id=3aca91f6"
import script from "./ContextMenuHeader.vue?vue&type=script&lang=js"
export * from "./ContextMenuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports